import * as requests from "../coraWebComponents/utils/requests";

export const register = async (data, googleBtnClicked = false) => {
  try {
    const urlExtension = googleBtnClicked ? "google" : "";

    let res = await requests.register(data, urlExtension);
    return res;
  } catch (error) {
    throw error;
  }
};
